import wrapWithProvider from './src/util/wrap-with-provider'

export const wrapRootElement = wrapWithProvider
